import {brief} from './brief';
import {connectedUser} from './connected-user';
import {productTour} from './product-tour';
import {ModuleTree} from 'vuex';
import {StoreState} from '@/brief-hub/store/state/StoreState';

export const modules: ModuleTree<StoreState> = {
    brief,
    connectedUser,
    productTour,
};
